import { Inject, Injectable } from '@angular/core';
import { ROLES_REPOSITORY, RolesRepository } from '@app/core/repositories/roles.repository';
import { Rol } from '@shared/interfaces/rol';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  constructor(
    @Inject(ROLES_REPOSITORY)
    protected repository: RolesRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  getItemUser(): Observable<any> {
    return this.repository.getItemUser();
  }

  getItemId(item: any): Observable<any> {
    return this.repository.getItemId(item);
  }

  add(rol: Rol): Observable<any> {
    return this.repository.add(rol);
  }

  edit(rol: Rol): Observable<any> {
    return this.repository.edit(rol);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
